import { config } from 'api';

export const RECEIVE_STATIC_CONTENT = 'RECEIVE_STATIC_CONTENT';

function receiveStaticContentPage(staticContentPage) {
  return {
    type: RECEIVE_STATIC_CONTENT,
    staticContent: staticContentPage.scribeContent.staticMicrosite,
  };
}

export function ensureStaticContent(staticContentId) {
  return (dispatch, getState, { network, router }) => {
    const existingStaticContent = getState().staticContent;
    if (existingStaticContent && existingStaticContent.docNo === staticContentId) {
      return Promise.resolve(); // product details already present in store
    }
    return network.get(`${config.apiBasePath}/static-content/${staticContentId}`, { proxyQueryParams: ['vreg'] })
      .then(staticContentPage => dispatch(receiveStaticContentPage(staticContentPage)))
      .catch(resp => network.handleStatus404(resp, router));
  };
}
